// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"363":"39d12103","883":"8c35bf25"}[chunkId] + ".chunk.css";
};